// Shared by the storefront and payment server. These are original USD prices.
export const GUN_CATALOG = [
  { id: 1, name: 'Halfbreed', price: 24.99, coloredPrice: 29.99 },
  { id: 2, name: 'Skinny Glock', price: 49.99, coloredPrice: 54.99 },
  { id: 3, name: 'Fat Glock', price: 49.99, coloredPrice: 54.99 },
  { id: 5, name: 'Revolver', price: 59.99, coloredPrice: 64.99 },
  { id: 4, name: 'Uzi', price: 79.99, coloredPrice: 84.99 },
  { id: 6, name: 'Suppressor', price: 4.99 },
];
export const GUN_COLORS = ['Black', 'Translucent White', 'Translucent Red', 'Translucent Blue', 'Translucent Green'];
export const COLORED_VARIANTS = ['Translucent Red', 'Translucent Blue', 'Translucent Green'];
export function gunPrice(product, color) {
  return COLORED_VARIANTS.includes(color) && product.coloredPrice ? product.coloredPrice : product.price;
}
